module.exports = __webpack_public_path__ + "static/img/vr4.4caf6bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vr/vr4.png
// module id = /vvt
// module chunks = 1